import { store } from '../store';

export default function checkPermission(permissionToCheck: string, options?: { allowTenantAdmin?: boolean }) {
  let hasPermission = false;

  const { user } = store.getState().auth;
  const tenantAdmin = (user as { is_tenant_admin?: unknown } | null)?.is_tenant_admin;

  if (options?.allowTenantAdmin
    && ['order-view', 'orderPendency-list', 'orderPendency-edit'].includes(permissionToCheck)
    && (tenantAdmin === true || tenantAdmin === 1 || tenantAdmin === '1')) {
    return true;
  }

  if (user && user.roles) {
    user.roles.forEach((role) => {
      if (role.permissions) {
        role.permissions.forEach((permission) => {
          if (permission.name === permissionToCheck) {
            hasPermission = true;
          }
        });
      }
    });
  }

  return hasPermission;
}
